export default __webpack_public_path__ + "static/media/arcos3_c.05515359.jpg";